import style from "@/ui-modules/core/redux-form/styles/FormWidget.module.scss";

import { type IAdvancedSearchFieldProps } from "./AdvancedSearchCriteria.js";

/**
 * Select input for controlled vocabulary list in advanced search criteria.
 */
export default function AdvancedSearchString(props: IAdvancedSearchFieldProps) {
  return (
    <input
      value={props.filterOperation.value}
      className={style.input_widget}
      onChange={(event: any) => props.onChangeState({ value: event.currentTarget.value }, false)}
      onBlur={props.onBlur}
      autoFocus={props.autoFocus}
    />
  );
}
